// engine
import { ArContainer, ArSpine, gameDispatcher, Pool, SPIN_MODE, userDispatcher } from "@aceroll/core";

const ANIMATION = {
    VFX_1: '1_rocket_blue_reel_eff',
    VFX_2: '1_rocket_red_reel_eff',
    VFX_3: '3_rockets_eff',
    VFX_4: '5_rockets_eff',
    FIREWORK: 'firework'
};

export class Fireworks extends ArContainer {
    #pool = new Pool();

    constructor() {
        super('fireworks');

        // this.spine = this.addChild(new ArSpine('spine-fireworks'));
        this.visible = true;

        // this.spine.addEvent('complete', () => {
        //     this.spine.reset();
        // });

        // gameDispatcher.onStateless('multiplier_add', ()=>{
        //     this.playAdd();
        // });

        gameDispatcher.onStateless('reel_eff', (x) => {
            this.playMult(x);
        });

        gameDispatcher.onStateless('multiplier_add_all', () => {
            this.playAddAll();
        });

        gameDispatcher.onStateless('multiplier_mult_all', () => {
            this.playMultAll();
        });

        window.fw = this;
    }

    #takeSpine() {
        let spine = this.#pool.get('spine');
        if (!spine) {
            spine = new ArSpine('spine-fireworks');
            spine.addEvent('complete', () => {
                this.#releaseSpine(spine);
            });
        }
        this.addChild(spine);
        return spine;
    }

    #releaseSpine(spine) {
        spine.parent.removeChild(spine);
        spine.reset();
        this.#pool.set('spine', spine);
        // console.log('pool status: ', this.#pool.size());
    }

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }

    getAnimationSpeed() {
        let speed = 1;
        const mode = userDispatcher.mode;
        switch (mode) {
            case SPIN_MODE.TURBO:
                speed = 1.3;
                break;
            case SPIN_MODE.SUPER_TURBO:
                speed = 1.5;
                break;
        }
        return speed;
    }

    play(spine, animation, loop = false) {
        spine.speed = 1;
        return spine.setImmediately(animation, loop);
    }

    // playAdd(reel) {
    //     this.spine.x = rell;
    //     return this.play(ANIMATION.VFX_1);
    // }

    playMult({ x, operation }) {
        const firework = this.#takeSpine();
        firework.position.set(x, -494); //over the panel
        switch (operation) {
            case '+':
                firework.setSkin('firework_blue');
                break;
            case 'x':
                firework.setSkin('firework_red');
                break;
        }
        this.play(firework, ANIMATION.FIREWORK); // don't need to wait for it


        const spine = this.#takeSpine();
        spine.position.set(x, 0);

        switch (operation) {
            case 'x':
                return this.play(spine, ANIMATION.VFX_2);
            case '+':
                return this.play(spine, ANIMATION.VFX_1);
        }
    }

    playAddAll() {
        const spine = this.#takeSpine();
        spine.position.set(490, 0);
        return this.play(spine, ANIMATION.VFX_4);
    }

    playMultAll() {
        const spine = this.#takeSpine();

        spine.position.set(490, 0);
        return this.play(spine, ANIMATION.VFX_3);
    }

    playFirework() {
        const spine = this.#takeSpine();

        spine.position.set(490, 0);
        spine.setSkin('firework_red');
        return this.play(spine, ANIMATION.FIREWORK);
    }
}
